// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2dbc3578","247":"f7a5defb","284":"11045e24","440":"3ab97897","627":"cfceec8e","834":"07fb06f7","867":"9aaafa60","923":"7c408129","938":"450b5a05","950":"8e593320"}[chunkId] + ".chunk.js";
};